<template>
  <div class="d-flex" :class="this.$store.state.menuToggle" id="wrapper">
    <TheSidemenu />
    <div id="page-content-wrapper">
      <TheTopmenu />
      <div class="container-fluid text-start">
        <p class="fs-6 m-2">
          {{ this.$route.meta.title }}
        </p>
        <div v-if="error" class="alert alert-danger">
          {{ error }}
        </div>
        <form class="row">
          <div class="col-md-6 col-xs-12">
            <div class="form-floating mb-3">
              <select
                class="form-control"
                id="category_ones_id"
                name="category_ones_id"
                v-model="formData.category_ones_id"
              >
                <option
                  v-for="item in categoryOnes"
                  :key="item.id"
                  :value="item.id"
                  :selected="item.id == formData.category_one.id"
                >
                  {{ item.name }}
                </option>
              </select>
              <label for="provinces">دسته والد-سطح یک</label>
            </div>
          </div>

          <div class="col-md-6 col-xs-12">
            <div class="form-floating mb-3">
              <input
                type="text"
                class="form-control"
                id="name"
                name="name"
                placeholder="نام دسته"
                v-model="formData.name"
              />
              <label for="name">نام *</label>
            </div>
          </div>
        </form>
        <div>
          <a
            class="btn btn-primary btn-block"
            @click="addEditCategorytwo()"
          >
            ثبت
          </a>
          <span v-show="showSpin" >
            <i class="fas fa-spinner fa-spin mt-3"></i>
          </span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import TheSidemenu from "../components/TheSidemenu";
import TheTopmenu from "../components/TheTopmenu";
import ArefApi from "../libs/api.js";

export default {
  name: "AddCategorytwo",
  created() {
    this.arefApi = new ArefApi(this);
  },
  components: {
    TheSidemenu,
    TheTopmenu,
  },
  data() {
    return {
      error: null,
      showSpin: false,
      formData: {
        id: this.$route.params.categorytwoId
          ? this.$route.params.categorytwoId
          : null,
        name: null,
        category_one: {
          id: null,
          name: null,
        },
        category_ones_id: null,
      },
      categoryOnes: null,
    };
  },
  methods: {
    addEditCategorytwo: function () {
      if (!this.validateFrm()) {
        return;
      }
      this.showSpin = true;
      const fn = this.formData.id ? "editCategorytwo" : "addCategorytwo";
      this.arefApi[fn](this.formData)
        .then(() => {
          this.$swal
            .fire({
              title: "",
              text: `ثبت با موفقیت انجام شد`,
              icon: "success",
              confirmButtonText: "متوجه شدم",
            }).then(() => {
              if(!this.formData.id){
                this.$router.push({name:'ListCategorytwos'})
              }
            });  
        })
        .catch((err) => {
          let alertText = "";
          if (err.data.errors) {
            for (let i in err.data.errors) {
              alertText += (alertText ? "" : ",") + `${err.data.errors[i]} `;
            }
          }
          this.$swal.fire({
            title: "!خطا",
            text: `${alertText}`,
            icon: "error",
            confirmButtonText: "متوجه شدم",
          });
        }).finally(()=>{
          this.showSpin = false;
        });
    },
    validateFrm: function () {
      this.error = null;
      if (!this.formData.name) {
        this.error = "نام باید بیشتر از دو حرف باشد";
        return false;
      }

      if (!this.formData.category_ones_id) {
        this.error = "دسته والد را وارد کنید";
        return false;
      }
      return true;
    },
    loadCategorytwoInfo: function () {
      return new Promise((resolve, reject) => {
        if (this.formData.id) {
          this.arefApi
            .getCategorytwo(this.formData.id)
            .then((resp) => {
              this.formData = resp.data;
              this.formData.category_ones_id = resp.data.category_one.id;
              resolve();
            })
            .catch((err) => {
              this.$swal
                .fire({
                  title: "خطا درنمایش اطلاعات !",
                  text: "دسته پیدا نشد ",
                  icon: "error",
                })
                .then(() => {
                  this.$router.push({ name: "EditCategorytwo" });
                });
              reject(err);
            });
        }
      });
    },
    getAllCategoryOnes: function () {
      this.arefApi.getCategoryonesIndex(1, true).then((resp) => {
        this.categoryOnes = resp.data;
      });
    },
  },
  mounted() {
    this.getAllCategoryOnes();
    this.loadCategorytwoInfo();
  },
};
</script>

